import { render } from "./Dialer.vue?vue&type=template&id=46163927&scoped=true"
import script from "./Dialer.vue?vue&type=script&lang=js"
export * from "./Dialer.vue?vue&type=script&lang=js"

import "./Dialer.vue?vue&type=style&index=0&id=46163927&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46163927"]])

export default __exports__